import { PrismicRichText } from 'prismic/types/richtext';
import { RichText } from 'components/rich-text/RichText';

import style from './FinePrint.module.scss';

type Props = {
  text?: PrismicRichText;
};

export const FinePrint = ({ text }: Props) => {
  if (!text) {
    return null;
  }

  return <RichText className={style.text}>{text}</RichText>;
};
